import {
  buildAddApplicant,
  addApplicantUsecase as _addApplicantUsecase,
} from "./add-applicant";

import {
  buildCheckSchedule,
  checkScheduleUsecase as _checkScheduleUsecase,
} from "./check-schedule";

import {
  buildFetchApplicants,
  fetchApplicantsUsecase as _fetchApplicantsUsecase,
} from "./fetch-applicants";

import {
  buildFetchApplicantsList,
  fetchApplicantsListUsecase as _fetchApplicantsListUsecase,
} from "./fetch-applicants-list";

import {
  buildFetchApplicant,
  fetchApplicantUsecase as _fetchApplicantUsecase,
} from "./fetch-applicant";

import {
  buildUpdateApplicant,
  updateApplicantUsecase as _updateApplicantUsecase,
} from "./update-applicant";

import {
  buildFetchTotalApplicants,
  fetchTotalApplicantsUsecase as _fetchTotalApplicantsUsecase,
} from "./fetch-total-applicants";

import {
  buildUpdateTotalNewApplicants,
  updateTotalNewApplicantsUsecase as _updateTotalNewApplicantsUsecase,
} from "./update-total-new-applicants";

import {
  buildUpdateApplicantDocuments,
  updateApplicantDocumentsUsecase as _updateApplicantDocumentsUsecase,
} from "./update-applicant-documents";

import {
  buildDeleteApplicantDocuments,
  deleteApplicantDocumentsUsecase as _deleteApplicantDocumentsUsecase,
} from "./delete-applicant-documents";

import ApplicantRepository from "../../ports/applicantRepository";

// eslint-disable-next-line import/no-anonymous-default-export
export default (dependencies: {
  applicantRepo: ApplicantRepository;
}): {
  addApplicant: _addApplicantUsecase;
  checkSchedule: _checkScheduleUsecase;
  fetchApplicants: _fetchApplicantsUsecase;
  fetchApplicantsList: _fetchApplicantsListUsecase;
  fetchApplicant: _fetchApplicantUsecase;
  fetchTotalApplicants: _fetchTotalApplicantsUsecase;
  updateApplicant: _updateApplicantUsecase;
  updateTotalNewApplicants: _updateTotalNewApplicantsUsecase;
  updateApplicantDocuments: _updateApplicantDocumentsUsecase;
  deleteApplicantDocuments: _deleteApplicantDocumentsUsecase;
} => {
  const { applicantRepo } = dependencies;

  const addApplicant = buildAddApplicant({ applicantRepo });
  const checkSchedule = buildCheckSchedule({ applicantRepo });
  const fetchApplicants = buildFetchApplicants({ applicantRepo });
  const fetchApplicantsList = buildFetchApplicantsList({ applicantRepo });
  const fetchApplicant = buildFetchApplicant({ applicantRepo });
  const fetchTotalApplicants = buildFetchTotalApplicants({ applicantRepo });
  const updateApplicant = buildUpdateApplicant({ applicantRepo });
  const updateTotalNewApplicants = buildUpdateTotalNewApplicants({ applicantRepo });
  const updateApplicantDocuments = buildUpdateApplicantDocuments({ applicantRepo });
  const deleteApplicantDocuments = buildDeleteApplicantDocuments({ applicantRepo });

  return { 
    addApplicant,
    checkSchedule,
    fetchApplicants,
    fetchApplicantsList,
    fetchApplicant,
    fetchTotalApplicants,
    updateApplicant,
    updateTotalNewApplicants,
    updateApplicantDocuments,
    deleteApplicantDocuments,
  };
};

export type addApplicantUsecase = _addApplicantUsecase;
export type checkScheduleUsecase = _checkScheduleUsecase;
export type fetchApplicantsUsecase = _fetchApplicantsUsecase;
export type fetchApplicantsListUsecase = _fetchApplicantsListUsecase;
export type fetchApplicantUsecase = _fetchApplicantUsecase;
export type fetchTotalApplicantsUsecase = _fetchTotalApplicantsUsecase;
export type updateApplicantUsecase = _updateApplicantUsecase;
export type updateTotalNewApplicantsUsecase = _updateTotalNewApplicantsUsecase;
export type updateApplicantDocumentsUsecase = _updateApplicantDocumentsUsecase;
export type deleteApplicantDocumentsUsecase = _deleteApplicantDocumentsUsecase;
